module.exports = __webpack_public_path__ + "static/media/PGL02@l.27793903.jpg";